import * as React from 'react';
import moment from 'moment';
import { License, LicenseDateRange } from 'types/license';
import { licenseDisplayTerms } from 'types/license';
import * as Core from 'components/core';
import LicensesTableRowActivations from './LicensesTableRowActivations';
import { getLicenseUniqueMachines } from 'utils/license';
type Props = {
  license: License;
  openDetailsInNewWindow?: boolean;
  showLabels?: boolean;
};
type State = {
  showActivationList: boolean;
};
export default class LicensesTableRow extends React.Component<Props, State> {
  static defaultProps = {
    showLabels: false,
    openDetailsInNewWindow: false,
  };
  state = {
    showActivationList: this.props.license.Terms !== 'site',
  };
  toggleActivationList = () => {
    this.setState({
      showActivationList: !this.state.showActivationList,
    });
  };
  render() {
    const { license, openDetailsInNewWindow, showLabels } = this.props;
    const uniqueMachines = getLicenseUniqueMachines(license);
    const { showActivationList } = this.state;

    // if `license` is a bundle, get the sublicenses
    const actualLicenses = [license]
      .concat(license.Sublicenses)
      .filter((l) => l.Seats != null && l.Seats.length > 0);
    // NB: number of seats on sublicenses is assumed to be the same within a parent license
    const seatCount = actualLicenses[0] ? actualLicenses[0].Seats.length : 0;
    return (
      <div className="LicensesTable-row" key={license.Serial}>
        <div className="LicensesTable-row-info-identifiers">
          <div className="LicensesTable-row-info-identifiers-licenseType">
            {license.AppName} {license.AppVersion} {license.DisplayType}
          </div>
          {license.Terms === 'site' && (
            <div className="LicensesTable-row-info-identifiers-siteLicenseSeatCount">
              {seatCount} Seat {licenseDisplayTerms[license.Terms]} License
            </div>
          )}
          {license.Terms === 'rental' && (
            <div className="LicensesTable-row-info-identifiers-rentalLabel">
              Rental License
            </div>
          )}
          <div className="LicensesTable-row-info-identifiers-serial">
            {license.Serial}
          </div>
          <div className="LicensesTable-row-info-identifiers-dateRange">
            {license.DateRange && <DateRange dateRange={license.DateRange} />}
          </div>
        </div>
        <div className="LicensesTable-row-info-activationCount">
          {uniqueMachines.length > 0 ? (
            <div>
              Active on{' '}
              {showActivationList ? (
                <>
                  {uniqueMachines.length}{' '}
                  {uniqueMachines.length === 1 ? 'machine' : 'machines'}{' '}
                  <Core.Button textLink onClick={this.toggleActivationList}>
                    hide
                  </Core.Button>
                </>
              ) : (
                <Core.Button textLink onClick={this.toggleActivationList}>
                  {uniqueMachines.length}{' '}
                  {uniqueMachines.length === 1 ? 'machine' : 'machines'}{' '}
                </Core.Button>
              )}
            </div>
          ) : (
            <div>{showLabels ? 'No activations' : 'None'}</div>
          )}
          {showActivationList && (
            <LicensesTableRowActivations
              license={license}
              activations={uniqueMachines}
            />
          )}
        </div>
        <div className="LicensesTable-row-actions">
          {openDetailsInNewWindow ? (
            <Core.Link newWindow to={`/account/licenses/${license.Serial}`}>
              View Details
            </Core.Link>
          ) : (
            <Core.Link to={`/account/licenses/${license.Serial}`}>
              View Details
            </Core.Link>
          )}
        </div>
      </div>
    );
  }
}
type DateRangeProps = {
  dateRange: LicenseDateRange | undefined | null;
};
class DateRange extends React.Component<DateRangeProps> {
  render() {
    const { dateRange } = this.props;
    if (dateRange === null || dateRange === undefined) {
      return null;
    }
    return (
      <>
        <div className="LicensesTable-row-info-date">
          {moment(dateRange.Start).format('ddd MMM Do YYYY')} —
        </div>
        <div className="LicensesTable-row-info-date">
          {moment(dateRange.End).format('ddd MMM Do YYYY')}
        </div>
      </>
    );
  }
}
